module.exports = __webpack_public_path__ + "img/slider-prev--dark.6aa08a76.svg";